import React from "react";
import { useFormContext, useWatch } from "react-hook-form";

import { AutoFormFieldProps } from "@autoform/react";
import { useApiUrl, useDataProvider } from "@refinedev/core";
import { z } from "zod";

import { RemoteSelect } from "@/components/fields/remote-select";
import { providerMetadataSchema } from "@/pages/events/schemas/event.ticketing.form";

export function ProviderSelectField({ id, inputProps }: AutoFormFieldProps) {
  const form = useFormContext();
  const value = useWatch({ name: id });
  const apiUrl = useApiUrl();
  const { custom } = useDataProvider()();

  return (
    <RemoteSelect<z.infer<typeof providerMetadataSchema>>
      value={value}
      triggerType="change"
      disabled={inputProps?.disabled}
      onValueChanged={(selected) => {
        form.setValue(id, selected, { shouldDirty: true });
        form.setValue("ticketing.provider", selected?.provider);
        inputProps.onChange({
          target: { name: id, value: selected },
        } as unknown as React.ChangeEvent<HTMLInputElement>);
      }}
      showSelected
      accessorFn={(option) => ({
        id: option?.id || "",
        name: option ? `${option?.provider}` : "",
        iconUrl: option?.logo,
      })}
      onSearch={async (query, onStatusChanged) => {
        if (!query) return [];
        onStatusChanged("loading");
        const response = await custom?.({
          url: `${apiUrl}/providers/explore`,
          method: "get",
          query: {
            q: query ?? "*",
            filters: "",
            limit: 10,
            page: 0,
            sortBy: "createdAt:asc",
            disableCaching: true,
          },
        });
        onStatusChanged("success");
        if (!response?.data) return [];
        return response?.data?.hits?.map((item: any) =>
          providerMetadataSchema.parse(item?.document),
        );
      }}
      label=""
    />
  );
}
